import { FC } from 'react'
import Card from 'shared/Cards/Card'
import Grade from 'shared/Grade'
import TextField from 'shared/Forms/TextField'
import { useNavigate } from 'react-router-dom'
import { ITeamReviewFormResponse } from 'screens/Protection/protection.types'

type Props = {
  data: ITeamReviewFormResponse
  values: Record<string, number>
}

type ArtefactItem = {
  key: string
  value: string
}

const ProtectionInfoCard: FC<Props> = ({ data, values }) => {
  const navigate = useNavigate()

  const artefacts: ArtefactItem[] =
    data.team.artefacts?.flatMap((record) => {
      try {
        return JSON.parse(record.artefacts) as ArtefactItem[]
      } catch {
        return []
      }
    }) ?? []

  return (
    <div style={{ display: 'flex', gap: 16, width: '100%' }}>
      <Card type='normal' style={{ flex: 1 }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <h2 className='text--caption-l text-700'>Информация</h2>

            <span className='text--link text--link-underline' onClick={() => navigate(`/teams/${data.team.id}`)}>
              Посмотреть информацию о команде
            </span>
          </div>

          <Grade grade={data.criteria.reduce((sum, c) => sum + (values[c.id] ?? 0), 0)} />

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 24,
            }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <TextField header='Команда'>{data.team.name}</TextField>
              <TextField header='Комната'>{data.room.name}</TextField>
              <TextField header='Защита'>{data.defence.name}</TextField>
              {artefacts.length > 0 && (
                <TextField header='Дополнительные материалы'>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 12,
                    }}
                  >
                    {artefacts.map((artefact, index) => (
                      <TextField
                        key={`${artefact.key}-${index}`}
                        header={artefact.key}
                        type='link'
                        link={artefact.value}
                      >
                        {artefact.value}
                      </TextField>
                    ))}
                  </div>
                </TextField>
              )}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <TextField header='Критериев'>{data.criteria.length}</TextField>
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ProtectionInfoCard
